module.exports = __webpack_public_path__ + "img/news1.4f31268b.png";